import React from 'react';
import { Navigate, useLocation } from "react-router-dom";

import AuthService from '../Auth';
import enviromment from '../../environment';

const PrivateRoute = ({ menu, privilegio, children, name }) => {

    const location = useLocation();

    const isAuthenticated = () => {
        return AuthService.isLoggedIn();
    }

    const hasPermission = (menu, privilegio) => {
        return AuthService.verifyPrivilegio(menu, privilegio) || (menu === "default" && privilegio === 'basic');
    }

    document.title = `${name} | ${enviromment.nome}`;

    if (isAuthenticated()) {
        if (hasPermission(menu, privilegio)) {
            return <>{children}</>;
        } else {
            return <Navigate to={{ pathname: "/401", state: { from: location.pathname } }} replace />;
        }
    }
    return <Navigate to={{ pathname: "/login", state: { from: location.pathname } }} replace />;

}

PrivateRoute.defaultProps = {
    privilegio: 'basic',
    menu: 'default',
};

export default PrivateRoute;